import * as React from "react";

function Profile(props) {
  return (
    <svg width={16} height={16} fill="none" {...props}>
      <path
        d="M7.72 8.037a3.185 3.185 0 100-6.37 3.185 3.185 0 000 6.37z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M2.667 12.468c-.001-.224.049-.445.146-.647.305-.61 1.166-.934 1.88-1.08a11.19 11.19 0 011.562-.22c.972-.085 1.95-.085 2.923 0 .525.037 1.047.11 1.562.22.714.146 1.574.439 1.88 1.08.195.41.195.888 0 1.3-.306.64-1.166.933-1.88 1.073-.514.115-1.037.19-1.562.226-.792.067-1.587.08-2.38.037-.183 0-.36 0-.543-.037a10.274 10.274 0 01-1.556-.226c-.72-.14-1.575-.433-1.886-1.074a1.52 1.52 0 01-.146-.652z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const ProfileIcon = React.memo(Profile);
export default ProfileIcon;
